import { render, staticRenderFns } from "./CreateAttachmentForm.vue?vue&type=template&id=61d6b77f&"
import script from "./CreateAttachmentForm.vue?vue&type=script&lang=ts&"
export * from "./CreateAttachmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports